import { TEXT_LANGUAGE_CHIPS } from '@byonco/voice/languages.js';

export const SITE_LANGS = TEXT_LANGUAGE_CHIPS.map((row) => row.code);

export const SITE_LANG_CODES = Object.fromEntries(
  SITE_LANGS.map((code) => [code, code.toUpperCase()])
);

export const SITE_LANG_NAMES = Object.fromEntries(
  TEXT_LANGUAGE_CHIPS.map((row) => [row.code, row.label])
);

export const SITE_LANG_HINTS = {
  en: 'English',
  hi: 'Hindi',
  mr: 'Marathi',
  ta: 'Tamil',
  te: 'Telugu',
  kn: 'Kannada',
  bn: 'Bengali',
  gu: 'Gujarati',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  nl: 'Dutch',
  pt: 'Portuguese',
  ru: 'Russian',
  ja: 'Japanese',
  ko: 'Korean',
  zh: 'Chinese'
};
